import { ApplicationView } from "@mixitone/mvc";
import { Link } from "react-router-dom";
import { CompetitionRegistrationPageController } from "../controllers/CompetitionRegistrationPageController";
import { PartnerInvitePanel } from "./PartnerInvitePanel";

const FinalInformationSection = () => {
  const controller = CompetitionRegistrationPageController.use();
  const { competition, registration, partnerLink, partnerEmail, partnerInviteSent, sendingPartnerInvite } =
    controller.state;
  const partnerJoined = registration?.partner_joined ?? false;

  if (!competition) {
    return null;
  }

  return (
    <>
      {registration!.player.isConfirmed && (
        <p className="text-sm">
          Your registration is confirmed. <Link to="/in/tournaments">See your tournaments.</Link>
        </p>
      )}
      {!registration!.player.isConfirmed && (
        <p className="text-sm">
          You have successfully registered for {competition.name}. We've emailed your registration details.
          You'll receive another email when your place is confirmed.
        </p>
      )}
      {partnerJoined && <p className="mt-2 text-sm">Your doubles partner has also joined.</p>}
      {!partnerJoined && partnerLink && (
        <div className="mt-4">
          <PartnerInvitePanel
            partnerLink={partnerLink}
            partnerEmail={partnerEmail}
            partnerInviteSent={partnerInviteSent}
            sendingPartnerInvite={sendingPartnerInvite}
            onPartnerEmailChange={(email) => {
              controller.state.partnerEmail = email;
            }}
            onSendInvite={() => controller.actionSendPartnerInvite()}
          />
        </div>
      )}
    </>
  );
};

export default ApplicationView(FinalInformationSection);
